/* Robocenter Produktgruppen: Filter, Sortierung, Endlos-Scroll (ohne Seiten).
   Alle Seiten der Gruppe werden im Hintergrund geladen; Filter und Sortierung arbeiten über alle Produkte,
   angezeigt wird in Schritten (Endlos-Scroll). Filterstand steht im URL-Hash (Zurück-Button funktioniert). */
(function () {
  var root = document.querySelector('[data-rc-coll]');
  if (!root) return;
  var grid = root.querySelector('[data-rc-grid]');
  var step = parseInt(root.getAttribute('data-step'), 10) || 36;
  var handle = root.getAttribute('data-handle');
  var q = function (s) { return root.querySelector(s); };
  var el = {
    filter: q('[data-rc-filter]'), groups: q('[data-rc-groups]'), scrim: q('[data-rc-scrim]'),
    count: q('[data-rc-count]'), chips: q('[data-rc-chips]'), empty: q('[data-rc-empty]'),
    more: q('[data-rc-more]'), sort: q('[data-rc-sort]'), sortwrap: q('[data-rc-sortwrap]'),
    open: q('[data-rc-open]'), fcount: q('[data-rc-fcount]')
  };

  /* ---------- Filter-Konfiguration je Produktgruppe ---------- */
  var SYSTEM = { id: 'sys', type: 'tags', label: 'Akku-System', options: [['12v', '12 V'], ['18v', '18 V'], ['20v', '20 V'], ['40v', '40 V'], ['60v', '60 V']] };
  var KAT = { id: 'kat', type: 'tags', label: 'Kategorie', options: [
    ['kat-bohrschrauber', 'Bohrschrauber'], ['kat-schlagschrauber', 'Schlagschrauber'], ['kat-hammer', 'Bohr- & Abbruchhämmer'],
    ['kat-winkelschleifer', 'Winkelschleifer'], ['kat-saegen', 'Sägen'], ['kat-multitools', 'Multitools & Fräsen'],
    ['kat-sauger-licht', 'Sauger, Gebläse & Leuchten'], ['kat-combo', 'Combo-Sets'], ['kat-messen', 'Messen'],
    ['kat-akkus', 'Akkus & Ladegeräte'], ['kat-saegeblaetter', 'Sägeblätter & Trennscheiben'], ['kat-zubehoer', 'Weiteres Zubehör']] };
  var ZB = { id: 'zb', type: 'tags', label: 'Zubehör für', options: [
    ['zb-maehroboter', 'Mähroboter'], ['zb-saugroboter', 'Saugroboter'], ['zb-fensterputzer', 'Fensterputzroboter'],
    ['zb-akku', 'Akku-Geräte'], ['zb-werkzeuge', 'Werkzeuge']] };
  var VENDOR = { id: 'vendor', type: 'attr', attr: 'vendor', label: 'Marke' };
  var TYPE = { id: 'type', type: 'attr', attr: 'type', label: 'Produktart' };
  var KIND = { id: 'kind', type: 'attr', attr: 'kind', label: 'Angebot', options: [['set', 'Set verfügbar'], ['sale', 'Aktionspreis']] };
  var PRICE = { id: 'price', type: 'price', label: 'Preis' };
  var ART = { id: 'art', type: 'tags', label: 'Produktart', options: [['akku', 'Akkus'], ['ladegeraet', 'Ladegeräte'], ['adapter', 'Adapter']] };
  var GARDEN = { id: 'geraet', type: 'tags', label: 'Gerätetyp', options: [
    ['rasenmaeher', 'Rasenmäher'], ['rasentrimmer|freischneider|kreiselschere', 'Rasentrimmer & Freischneider'], ['heckenschere|heckenschneider|strauchschere', 'Heckenscheren'],
    ['kettensaege|hochentaster', 'Kettensägen & Hochentaster'], ['gartenschere|astschere|gehoelzschneider', 'Garten- & Astscheren'],
    ['laubblaeser|sauger|laubsauger|handsauger|saughaecksler', 'Laubbläser & Sauger'], ['trennschleifer', 'Trennschleifer'], ['erdbohrer', 'Erdbohrer'],
    ['spritzgeraet', 'Spritzgeräte'], ['kehrgeraet', 'Kehrgeräte'], ['druckreiniger|hochdruckreiniger', 'Druck- & Hochdruckreiniger'],
    ['vertikutierer', 'Vertikutierer'], ['kombimotor|kombiwerkzeug', 'Kombi-Systeme'], ['schneefraese', 'Schneefräsen']] };
  var SYSTEM_STIHL = { id: 'ssys', type: 'tags', label: 'Akku-System (Stihl)', options: [['as-system', 'AS-System'], ['ak-system', 'AK-System'], ['ap-system', 'AP-System']] };

  var PROFILES = {
    mower: [VENDOR,
      { id: 'nav', type: 'tags', label: 'Navigationstyp', options: [['rtk', 'RTK (Satellit)'], ['lidar', 'LiDAR']] },
      { id: 'area', type: 'range', attr: 'area', label: 'Max. Fläche', unit: 'm²', buckets: [[0, 500, 'bis 500 m²'], [501, 1000, '501 – 1.000 m²'], [1001, 2000, '1.001 – 2.000 m²'], [2001, 5000, '2.001 – 5.000 m²'], [5001, 1e9, 'über 5.000 m²']] },
      { id: 'slope', type: 'range', attr: 'slope', label: 'Max. Steigung', buckets: [[0, 45, 'bis 45 %'], [46, 99, 'über 45 %']] },
      { id: 'feat', type: 'tags', label: 'Ausstattung', options: [['allrad', 'Allradantrieb'], ['zerotrim', 'ZeroTrim'], ['4g', '4G-Mobilfunk']] },
      KIND, PRICE],
    vacuum: [VENDOR,
      { id: 'nav', type: 'tags', label: 'Navigation', options: [['lidar', 'LiDAR']] },
      { id: 'feat', type: 'tags', label: 'Ausstattung', options: [['omni', 'OMNI-Station'], ['kompakt', 'Kompakt']] },
      KIND, PRICE],
    window: [VENDOR, PRICE],
    garden: [GARDEN, VENDOR, SYSTEM, SYSTEM_STIHL, KIND, PRICE],
    battery: [ART, VENDOR, SYSTEM, PRICE],
    tools: [VENDOR, KAT, SYSTEM, KIND, PRICE],
    accessory: [ZB, KAT, VENDOR, PRICE],
    generic: [TYPE, VENDOR, KIND, PRICE]
  };
  var BY_HANDLE = {
    'maehroboter': 'mower', 'saug-wischroboter': 'vacuum', 'fensterputzer': 'window',
    'akku-gartengeraete': 'garden', 'akku-rasenmaeher': 'garden', 'rasentrimmer-freischneider': 'garden', 'heckenscheren': 'garden', 'kettensaegen-hochentaster': 'garden', 'garten-astscheren': 'garden', 'laubblaeser-sauger': 'garden', 'trennschleifer': 'garden', 'erdbohrer': 'garden', 'spritzgeraete': 'garden', 'kehrgeraete': 'garden', 'druck-hochdruckreiniger': 'garden', 'vertikutierer': 'garden', 'kombi-systeme': 'garden', 'schneefraesen': 'garden', 'akkus-ladegeraete': 'battery',
    'akku-werkzeuge': 'tools', 'elektrowerkzeuge': 'tools', 'messen-werkstatt': 'tools', 'werkstatt': 'tools',
    'bohrschrauber': 'tools', 'schlagschrauber': 'tools', 'bohrhaemmer': 'tools', 'winkelschleifer': 'tools', 'saegen': 'tools',
    'multitools-fraesen': 'tools', 'sauger-geblaese-leuchten': 'tools', 'combo-sets': 'tools', 'akkus-ladegeraete-werkzeuge': 'tools',
    'saegeblaetter-scheiben': 'tools', 'weiteres-zubehoer-werkzeuge': 'tools',
    'zubehoer-ersatzteile': 'accessory', 'zubehoer-maehroboter': 'accessory', 'zubehoer-saug-wischroboter': 'accessory',
    'zubehoer-fensterputzer': 'accessory', 'zubehoer-akku-geraete': 'accessory', 'zubehoer-werkzeuge': 'accessory',
    'garten': 'generic', 'haushalt': 'generic', 'all': 'generic'
  };
  var CONFIG = PROFILES[BY_HANDLE[handle] || 'generic'];

  /* ---------- Karten einlesen / nachladen ---------- */
  var all = [];
  function read(card) {
    var d = card.dataset;
    card._rc = {
      idx: parseInt(d.idx, 10) || 0, price: (parseInt(d.price, 10) || 0) / 100, vendor: d.vendor || '', type: d.type || '',
      tags: (d.tags || '').split(' '), title: d.title || '', area: d.area ? parseFloat(d.area) : null,
      slope: d.slope ? parseFloat(d.slope) : null, kind: d.kind || ''
    };
    return card;
  }
  Array.prototype.forEach.call(grid.querySelectorAll('[data-rc-card]'), function (c) { all.push(read(c)); });

  var nextUrl = grid.getAttribute('data-next');
  var loaded = null; // Promise, sobald alles geladen ist
  function loadAll() {
    if (loaded) return loaded;
    var pages = parseInt(grid.getAttribute('data-pages'), 10) || 1, current = 1;
    var jobs = [];
    function fetchPage(n, tries) {
      var u = new URL(nextUrl, location.href); u.searchParams.set('page', n);
      return fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      }).catch(function (e) { // z. B. kurzzeitige 429-Antwort
        if (tries < 3) return new Promise(function (res) { setTimeout(res, 900 * (tries + 1)); }).then(function () { return fetchPage(n, tries + 1); });
        return '';
      });
    }
    if (!nextUrl) { loaded = Promise.resolve(); return loaded; }
    for (var n = current + 1; n <= pages; n++) jobs.push(fetchPage(n, 0));
    loaded = Promise.all(jobs).then(function (htmls) {
      htmls.forEach(function (html) {
        if (!html) return;
        var g = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-rc-grid]');
        if (!g) return;
        Array.prototype.forEach.call(g.querySelectorAll('[data-rc-card]'), function (c) {
          var node = document.importNode(c, true); node.hidden = true; grid.appendChild(node); all.push(read(node));
        });
      });
    });
    return loaded;
  }

  /* ---------- Zustand ---------- */
  var state = { sort: '', sel: {}, price: [null, null] };
  function fmt(n) { return n.toLocaleString('de-AT'); }
  function inState(g) {
    if (g.type === 'price') return state.price[0] != null || state.price[1] != null;
    return state.sel[g.id] && state.sel[g.id].length > 0;
  }
  function anyTag(r, key) { return key.indexOf('|') > -1 ? key.split('|').some(function (k) { return r.tags.indexOf(k) > -1; }) : r.tags.indexOf(key) > -1; }
  function matchGroup(c, g) {
    var r = c._rc, s = state.sel[g.id] || [];
    if (g.type === 'price') {
      if (state.price[0] != null && r.price < state.price[0]) return false;
      if (state.price[1] != null && r.price > state.price[1]) return false;
      return true;
    }
    if (!s.length) return true;
    if (g.type === 'attr') return s.indexOf(r[g.attr]) > -1;
    if (g.type === 'tags') return s.some(function (t) { return anyTag(r, t); });
    if (g.type === 'kw') return s.some(function (k) { return has(c, g, k); });
    if (g.type === 'range') {
      var v = r[g.attr]; if (v == null) return false;
      return s.some(function (i) { var b = g.buckets[i]; return v >= b[0] && v <= b[1]; });
    }
    return true;
  }
  function matches(c, skip) {
    for (var i = 0; i < CONFIG.length; i++) { if (CONFIG[i] !== skip && !matchGroup(c, CONFIG[i])) return false; }
    return true;
  }

  /* ---------- Optionen je Gruppe ermitteln ---------- */
  function optionsOf(g) {
    var out = [], map = {};
    if (g.type === 'attr') {
      if (g.options) { g.options.forEach(function (o) { out.push({ key: o[0], label: o[1] }); }); }
      else {
        all.forEach(function (c) { var v = c._rc[g.attr]; if (v && !map[v]) { map[v] = 1; out.push({ key: v, label: v }); } });
        out.sort(function (a, b) { return a.label.localeCompare(b.label, 'de'); });
      }
    } else if (g.type === 'tags' || g.type === 'kw') {
      g.options.forEach(function (o) { out.push({ key: o[0], label: o[1] }); });
    } else if (g.type === 'range') {
      g.buckets.forEach(function (b, i) { out.push({ key: String(i), label: b[2] }); });
    }
    return out;
  }
  function has(c, g, key) {
    var r = c._rc;
    if (g.type === 'attr') return r[g.attr] === key;
    if (g.type === 'tags') return anyTag(r, key);
    if (g.type === 'kw') { var o = g.options.filter(function (x) { return x[0] === key; })[0]; return !!o && new RegExp(o[2]).test(r.title); }
    if (g.type === 'range') { var v = r[g.attr], b = g.buckets[+key]; return v != null && v >= b[0] && v <= b[1]; }
    return false;
  }
  function relevant(g) { // Gruppe nur zeigen, wenn sie etwas unterscheidet
    if (g.type === 'price') { var p = all.map(function (c) { return c._rc.price; }); return all.length > 1 && Math.min.apply(null, p) !== Math.max.apply(null, p); }
    var used = optionsOf(g).filter(function (o) { return all.some(function (c) { return has(c, g, o.key); }); });
    if (used.length === 0) return false;
    if (used.length === 1) { var k = used[0].key; return !all.every(function (c) { return has(c, g, k); }); }
    return true;
  }

  /* ---------- Filter-Seitenleiste bauen ---------- */
  var built = false, active = [];
  function esc(s) { return String(s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function build() {
    active = CONFIG.filter(relevant);
    var html = '';
    active.forEach(function (g) {
      html += '<details class="rc-f__group" open data-g="' + g.id + '"><summary>' + esc(g.label) + '</summary><div class="rc-f__body">';
      if (g.type === 'price') {
        var p = all.map(function (c) { return c._rc.price; });
        var lo = Math.floor(Math.min.apply(null, p)), hi = Math.ceil(Math.max.apply(null, p));
        html += '<div class="rc-f__price"><label><span>von</span><input type="number" inputmode="numeric" min="0" placeholder="' + fmt(lo) + '" data-pmin><i>€</i></label>' +
          '<label><span>bis</span><input type="number" inputmode="numeric" min="0" placeholder="' + fmt(hi) + '" data-pmax><i>€</i></label></div>';
      } else {
        optionsOf(g).forEach(function (o) {
          if (!all.some(function (c) { return has(c, g, o.key); })) return;
          html += '<label class="rc-f__opt" data-o="' + esc(o.key) + '"><input type="checkbox" value="' + esc(o.key) + '" data-g="' + g.id + '"><span class="rc-f__box" aria-hidden="true"></span><span class="rc-f__lbl">' + esc(o.label) + '</span><em></em></label>';
        });
      }
      html += '</div></details>';
    });
    el.groups.innerHTML = html;
    el.filter.hidden = false;
    if (el.open) el.open.hidden = false;
    el.sortwrap.hidden = false;
    root.classList.add('rc-coll--filter');
    built = true;
  }

  /* ---------- Darstellung ---------- */
  var limit = step, rendering = false;
  function sorted(list) {
    var a = list.slice();
    if (state.sort === 'price-asc') a.sort(function (x, y) { return x._rc.price - y._rc.price || x._rc.idx - y._rc.idx; });
    else if (state.sort === 'price-desc') a.sort(function (x, y) { return y._rc.price - x._rc.price || x._rc.idx - y._rc.idx; });
    else if (state.sort === 'title') a.sort(function (x, y) { return x._rc.title.localeCompare(y._rc.title, 'de'); });
    else a.sort(function (x, y) { return x._rc.idx - y._rc.idx; });
    return a;
  }
  function refresh(resetLimit) {
    if (!built) build();
    if (resetLimit) limit = step;
    var list = sorted(all.filter(function (c) { return matches(c); }));
    var frag = document.createDocumentFragment();
    var shown = {};
    list.forEach(function (c, i) { c.hidden = i >= limit; shown[c._rc.idx] = true; frag.appendChild(c); });
    all.forEach(function (c) { if (!shown[c._rc.idx]) { c.hidden = true; frag.appendChild(c); } });
    grid.appendChild(frag);

    var pending = !!nextUrl;
    el.count.textContent = (pending && anyActive() ? 'Wird gefiltert … ' : '') + list.length + (list.length === 1 ? ' Produkt' : ' Produkte');
    el.empty.hidden = !(list.length === 0 && !pending);
    grid.hidden = list.length === 0 && !pending;
    el.more.hidden = !(pending || limit < list.length);
    updateOptions();
    updateChips();
    writeHash();
    watch();
  }
  function anyActive() { return CONFIG.some(inState); }
  function updateOptions() {
    active.forEach(function (g) {
      if (g.type === 'price') return;
      var s = state.sel[g.id] || [];
      Array.prototype.forEach.call(el.groups.querySelectorAll('.rc-f__opt'), function (lab) {
        var input = lab.querySelector('input');
        if (input.getAttribute('data-g') !== g.id) return;
        var n = all.filter(function (c) { return matches(c, g) && has(c, g, input.value); }).length;
        lab.querySelector('em').textContent = n;
        input.checked = s.indexOf(input.value) > -1;
        lab.classList.toggle('is-zero', n === 0 && !input.checked);
        input.disabled = n === 0 && !input.checked;
      });
    });
    var pmin = el.groups.querySelector('[data-pmin]'), pmax = el.groups.querySelector('[data-pmax]');
    if (pmin && document.activeElement !== pmin) pmin.value = state.price[0] != null ? state.price[0] : '';
    if (pmax && document.activeElement !== pmax) pmax.value = state.price[1] != null ? state.price[1] : '';
  }
  function labelOf(g, key) {
    var o = optionsOf(g).filter(function (x) { return x.key === key; })[0]; return o ? o.label : key;
  }
  function updateChips() {
    var html = '', n = 0;
    active.forEach(function (g) {
      if (g.type === 'price') {
        if (state.price[0] != null || state.price[1] != null) {
          n++;
          var t = (state.price[0] != null ? 'ab ' + fmt(state.price[0]) + ' €' : '') + (state.price[0] != null && state.price[1] != null ? ' ' : '') + (state.price[1] != null ? 'bis ' + fmt(state.price[1]) + ' €' : '');
          html += '<button type="button" class="rc-chip" data-chip-price>' + esc(t) + ' <span aria-hidden="true">×</span></button>';
        }
        return;
      }
      (state.sel[g.id] || []).forEach(function (k) {
        n++;
        html += '<button type="button" class="rc-chip" data-chip="' + g.id + '" data-key="' + esc(k) + '">' + esc(labelOf(g, k)) + ' <span aria-hidden="true">×</span></button>';
      });
    });
    if (n) html += '<button type="button" class="rc-chip rc-chip--reset" data-rc-reset>Alle zurücksetzen</button>';
    el.chips.innerHTML = html; el.chips.hidden = !n;
    if (el.fcount) { el.fcount.textContent = n; el.fcount.hidden = !n; }
  }

  /* ---------- URL-Hash ---------- */
  function writeHash() {
    var parts = [];
    CONFIG.forEach(function (g) {
      if (g.type === 'price') {
        if (state.price[0] != null || state.price[1] != null) parts.push('preis=' + (state.price[0] != null ? state.price[0] : '') + '-' + (state.price[1] != null ? state.price[1] : ''));
      } else if (state.sel[g.id] && state.sel[g.id].length) parts.push(g.id + '=' + state.sel[g.id].map(encodeURIComponent).join(','));
    });
    if (state.sort) parts.push('sort=' + state.sort);
    var h = parts.length ? '#' + parts.join('&') : '';
    if (h !== location.hash) { try { history.replaceState(null, '', location.pathname + location.search + h); } catch (e) {} }
  }
  function readHash() {
    var h = location.hash.replace(/^#/, ''); if (!h) return false;
    var any = false;
    h.split('&').forEach(function (p) {
      var kv = p.split('='), k = kv[0], v = kv[1] || '';
      if (k === 'sort') { state.sort = v; if (el.sort) el.sort.value = v; any = true; return; }
      if (k === 'preis') { var pr = v.split('-'); state.price = [pr[0] !== '' ? +pr[0] : null, pr[1] !== '' ? +pr[1] : null]; any = true; return; }
      var g = CONFIG.filter(function (x) { return x.id === k; })[0];
      if (g) { state.sel[g.id] = v.split(',').map(decodeURIComponent).filter(Boolean); any = true; }
    });
    return any;
  }

  /* ---------- Endlos-Scroll ---------- */
  var io = null;
  function watch() {
    if (!('IntersectionObserver' in window)) { limit = 1e6; return; }
    if (!io) {
      io = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting || es[0].boundingClientRect.top < 0) { limit += step; refresh(); }
      }, { rootMargin: '700px 0px' });
    }
    io.disconnect();
    if (!el.more.hidden) io.observe(el.more);
  }

  /* ---------- Ereignisse ---------- */
  function ensureAll(fn) { fn(); } // Filter ist erst nach vollständigem Laden bedienbar
  function toggle(g, key, on) {
    var s = state.sel[g] || []; var i = s.indexOf(key);
    if (on && i < 0) s.push(key); if (!on && i > -1) s.splice(i, 1);
    state.sel[g] = s;
  }
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('.rc-f__opt input')) { toggle(t.getAttribute('data-g'), t.value, t.checked); ensureAll(function () { refresh(true); }); }
    else if (t === el.sort) { state.sort = t.value; ensureAll(function () { refresh(true); }); }
  });
  var pt;
  root.addEventListener('input', function (e) {
    var t = e.target;
    if (t.matches('[data-pmin],[data-pmax]')) {
      clearTimeout(pt);
      pt = setTimeout(function () {
        var a = parseFloat(el.groups.querySelector('[data-pmin]').value), b = parseFloat(el.groups.querySelector('[data-pmax]').value);
        state.price = [isNaN(a) ? null : a, isNaN(b) ? null : b];
        ensureAll(function () { refresh(true); });
      }, 450);
    }
  });
  function resetAll() { state.sel = {}; state.price = [null, null]; ensureAll(function () { refresh(true); }); }
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button'); if (!t) return;
    if (t.hasAttribute('data-rc-reset')) resetAll();
    else if (t.hasAttribute('data-chip-price')) { state.price = [null, null]; refresh(true); }
    else if (t.hasAttribute('data-chip')) { toggle(t.getAttribute('data-chip'), t.getAttribute('data-key'), false); refresh(true); }
    else if (t.hasAttribute('data-rc-close')) closeDrawer();
    else if (t.hasAttribute('data-rc-open')) openDrawer();
  });
  if (el.scrim) el.scrim.addEventListener('click', closeDrawer);
  function openDrawer() { root.classList.add('rc-coll--drawer'); el.scrim.hidden = false; document.documentElement.style.overflow = 'hidden'; }
  function closeDrawer() { root.classList.remove('rc-coll--drawer'); el.scrim.hidden = true; document.documentElement.style.overflow = ''; }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  window.addEventListener('hashchange', function () { state = { sort: '', sel: {}, price: [null, null] }; if (el.sort) el.sort.value = ''; readHash(); ensureAll(function () { refresh(true); }); });

  /* ---------- Start ---------- */
  var hadHash = readHash();
  root.classList.add('rc-coll--filter'); // Platz für die Filterspalte sofort reservieren
  function start() { nextUrl = null; build(); refresh(true); }
  if (nextUrl) { loadAll().then(start); } else { start(); }
})();
